import {TaskDefinition} from "./task-definition";
import {TaskRealization} from "./task-realization";
import { KpiMultiplier } from "../services/ranking-service/ranking-definition";
import { KpiDefinition } from "./kpi-definition";

export type TaskDefinitionsByTaskDefinitionId = { [taskDefinitionId: number]: TaskDefinition }
export type TaskRealizationsByTaskDefinitionId = { [taskDefinitionId: number]: TaskRealization }

export type MapOfNumberTo<T> = { [key: number]: T }
export type MapOfStringTo<T> = { [key: string]: T }
export type Params = MapOfStringTo<any>

export class Utils {

  static toMapByNumeric<T>(collection: T[], field: string): MapOfNumberTo<T> {
    const map = {}
    for (let item of collection) {
      map[item[field]] = item;
    }
    return map;
  }

  static compareDatesDescending(a: Date, b: Date): number {
    if (new Date(a).getTime() > new Date(b).getTime()) {
      return -1;
    }
    else if (new Date(a).getTime() < new Date(b).getTime()) {
      return 1;
    }
    else {
      return 0;
    }
  }

  static compareKpisByPriorityDescendingThenMultiplierDescending(a: KpiMultiplier, b: KpiMultiplier, kpiDefinitionsById: MapOfNumberTo<KpiDefinition>): number {
    let kpiA = kpiDefinitionsById[a.kpiId];
    let kpiB = kpiDefinitionsById[b.kpiId];

    if (kpiA && kpiB) {
      let priorityA = kpiA.params.priority;
      let priorityB = kpiB.params.priority;

      if (priorityA && priorityB) {
        return priorityB - priorityA;
      }
    }

    return b.multiplier - a.multiplier;
  }
}



// WEBPACK FOOTER //
// ./src/modules/ranking/interfaces/utils.ts